import { render, staticRenderFns } from "./InboundSummary.vue?vue&type=template&id=c95789c0&scoped=true"
import script from "./InboundSummary.vue?vue&type=script&lang=js"
export * from "./InboundSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95789c0",
  null
  
)

export default component.exports